import { ControlledSelectField } from 'components/Form';
import type { ConstructionTypeData } from 'gql/graphql';
import { ProjectMethodologyEnum } from 'gql/graphql';
import { useProjectData } from 'hooks/useProjectData';
import { useContractConstructionTypes } from 'pages/Project/Common/Contract/hooks/useContractConstructionTypes';

import type React from 'react';
import { useMemo } from 'react';
import type { UseControllerProps } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { useConstructionTypes } from '../hooks/useConstructionTypes';

interface IActKC2ConstructionTypeField extends UseControllerProps {
    label?: string;
    required?: boolean;
    useWorkOrderTypes?: boolean;
}

export const ActKC2ConstructionTypeField: React.FC<IActKC2ConstructionTypeField> = (props) => {
    const { name, control, rules, label = 'Вид строительства', required, useWorkOrderTypes } = props;
    const { id: projectId, orderId } = useParams();
    const { projectData } = useProjectData(projectId);
    const { contractId } = projectData || {};
    const [contractConstructionTypes] = useContractConstructionTypes(
        contractId,
        ProjectMethodologyEnum.Uer,
        !useWorkOrderTypes,
    );
    const [workOrderConstructionTypes] = useConstructionTypes(
        Number(orderId),
        useWorkOrderTypes,
        `workOrderConstructionTypes${Number(orderId)}_actSeasons`,
    );

    const constructionTypes = useMemo(
        () =>
            ((useWorkOrderTypes ? workOrderConstructionTypes : contractConstructionTypes) || []).map(
                (item: ConstructionTypeData) => ({
                    id: item.id,
                    label: item.name,
                }),
            ),
        [contractConstructionTypes, useWorkOrderTypes, workOrderConstructionTypes],
    );

    return (
        <ControlledSelectField
            control={control}
            label={label}
            name={name}
            items={constructionTypes}
            rules={rules}
            required={required}
        />
    );
};

ActKC2ConstructionTypeField.displayName = 'ActKC2ConstructionTypeField';
